module.exports = __webpack_public_path__ + "static/media/a87.f36ea449.jpg";